import styled from 'styled-components'
import colors from '@settings/styleSettings'
import PrimaryButton from '@components/inputs/button/primaryButton'

export const AddButtonModal = styled(PrimaryButton)`
  width: 180px !important;
  @media(max-width: 550px ){
    width: 50px !important;
  }
`
export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`
export const IconAdd = styled.div`
  color: ${colors.background};
`
export const Text = styled.div`
  font-family: Circular-Std-Bold;

  @media screen and (max-width: 550px){
    display: none;

  }
`
export const IconAndText = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 550px){
    justify-content: center;
  }
`
